import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import FullCalendar from '@fullcalendar/react';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import './CalendarOneDay.css';
import moment from 'moment';
import { addfifteenMinutes, capitalizeFirst, formatTimeRange, getAppointmentDuration, subtractFifteenMinutes } from '../Common/CommonFunction';

const CalendarOneDay = (props) => {
    const calendarRef = useRef();
    const [eventDataSet, setEventDataSet] = useState([]);
    // Build a product_category_id -> type lookup from localStorage for dynamic appointment coloring
    const _catTypeMap = (() => {
        try {
            const cats = JSON.parse(localStorage.getItem('showCategory') || '[]');
            return cats.reduce((acc, c) => { acc[c.product_category_id] = c.type; return acc; }, {});
        } catch (e) { return {}; }
    })();
    // Admin check: role_id === 1 (same convention as LayoutMobile.js)
    const isAdmin = (() => {
        try {
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            return userData?.roles?.[0]?.role_id === 1;
        } catch (e) { return false; }
    })();

    // Update calendar view when date changes
    useEffect(() => {
        if (calendarRef.current && props.passDate) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(props.passDate);
        }
    }, [props.passDate]);
    function truncateText(text, maxLength = 40) {
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength) + '...';
    }


    useEffect(() => {
        const eventData = [];

        if (
            props &&
            props.data &&
            props.data.appointmentData &&
            props.data.appointmentData.length > 0
        ) {
            try {
                props.data.appointmentData.forEach((a) => {
                    if (a && a.rooms && a.rooms.length > 0) {
                        a.rooms.forEach((item) => {
                            if (item && (item.type === "lunch" || item.type === "spacer" || item.type === "block")) {
                                const spacerEvent = {
                                    title: item.type?.toUpperCase() ?? item.name,
                                    resourceId: a.room_id,
                                    start: moment(item.start_time, "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                                    end: moment(item.end_time, "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                                    backgroundColor: item.type === "block" ? '#A4A4A4' : item.type === "lunch" ? '#A4A4A4' : '#D1D1D1',
                                    borderColor: item.type === "block" ? '#A4A4A4' : item.type === "lunch" ? '#A4A4A4' : '#D1D1D1',
                                    textColor: '#4A4A4A',
                                    data: { ...item, room_name: a.room_name, room_type: a.room_type },
                                };
                                eventData.push(spacerEvent);
                            }
                            if (item && (item.type === 'lantum')) {
                                const spacerEvent = {
                                    title: item.type?.toUpperCase() ?? 'lantum',
                                    resourceId: item.room_id,
                                    start: moment(subtractFifteenMinutes(item.lantum_start_time), "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                                    end: moment((item.lantum_start_time), "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                                    backgroundColor: '#4A4A4A',
                                    borderColor: '#4A4A4A',
                                    textColor: '#fff',
                                    data: { ...item, room_name: a.room_name, room_type: a.room_type },
                                };
                                const spacerEventNew = {
                                    title: item.type?.toUpperCase() ?? 'lantum',
                                    resourceId: item.room_id,
                                    start: moment((item.lantum_end_time), "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                                    end: moment(addfifteenMinutes(item.lantum_end_time), "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                                    backgroundColor: '#4A4A4A',
                                    borderColor: '#4A4A4A',
                                    textColor: '#fff',
                                    data: { ...item, room_name: a.room_name, room_type: a.room_type },
                                };
                                eventData.push(spacerEventNew);
                                eventData.push(spacerEvent);
                            }

                            if (item && item.type === "appointment") {
                                // console.log('item ::::',item)
                                const appointmentEvent = {
                                    title: `${formatTimeRange(item.start_time, item.end_time).start} - ${item?.patient?.first_name} ${item?.patient?.last_name} | ${item?.product_category_name && item?.product_category_name} | ${getAppointmentDuration(item.start_time, item.end_time)} minutes | ${item?.language_name ?? "English"} | ${item.preferred_gender ? capitalizeFirst(item.preferred_gender) : "Male"}`,
                                    resourceId: a.room_id,
                                    start: moment(item.start_time, "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                                    end: moment(item.end_time, "YYYY-MM-DD HH:mm:ss.SSS").format("YYYY-MM-DD[T]HH:mm:ss"),
                                    // backgroundColor: '#008385',
                                    // borderColor: '#008385',
                                    backgroundColor: (_catTypeMap[item?.product_category_id] === 'corporate' || item?.product_category_id == 3) ? '#90CAF9' : '#008385',
                                    borderColor: (_catTypeMap[item?.product_category_id] === 'corporate' || item?.product_category_id == 3) ? '#90CAF9' : '#008385',
                                    textColor: '#F0FAFA',
                                    data: { ...item, room_name: a.room_name, room_type: a.room_type },
                                };
                                eventData.push(appointmentEvent);
                            }
                        });
                    }
                });

                setEventDataSet(eventData);
            } catch (error) {
                console.error("Error processing event data:", error);
            }
        }
    }, [props.passDate, props.data]);
    // console.log('eventDataSet:::',eventDataSet)
    // console.log('eventDataSet::props:',props)
    return (
        <div style={{ paddingBottom: "20px" }}>
            {props.passDate && (
                <FullCalendar
                    timeZone="UTC"
                    ref={calendarRef}
                    plugins={[resourceTimeGridPlugin, interactionPlugin]}
                    initialView="resourceTimeGridDay"
                    initialDate={props.passDate}
                    headerToolbar={{
                        left: '',
                        center: 'title',
                        right: '',
                    }}
                    // slotMinTime="00:00:00"
                    // slotMaxTime="24:00:00"
                    slotMinTime="06:00:00"
                    slotMaxTime="22:00:00"
                    slotDuration="01:00:00"
                    slotLabelFormat={{
                        hour: 'numeric',
                        minute: '2-digit',
                        meridiem: 'short'
                    }}
                    selectable={true}
                    // select={(info) => {
                    //     props.createNewAppointment?.(info);
                    // }}
                    eventClick={(info) => {
                        // console.log('info:', info?.event?._def?.extendedProps)
                        // return
                        if (info) {
                            props.openModal?.(info.el, info.event);
                        }
                    }}
                    eventContent={(eventInfo) => {
                        const eventData = eventInfo?.event?._def?.extendedProps?.data;

                        // For lantum events with clinicians, wrap with Tooltip
                        if (eventData?.type === 'lantum' && eventData?.clinicians && eventData.clinicians.length > 0) {
                            const tooltipContent = (
                                <div>
                                    {eventData.clinicians.map((clinician, index) => {
                                        const startTime = moment.utc(clinician.start).format('hh:mm a');
                                        const endTime = moment.utc(clinician.end).format('hh:mm a');
                                        const gender = clinician.clinician_gender ?
                                            (clinician.clinician_gender.toLowerCase() === 'male' ? '(M)' :
                                                clinician.clinician_gender.toLowerCase() === 'female' ? '(F)' : '') : '';
                                        return (
                                            <div key={index} style={{ marginBottom: index < eventData.clinicians.length - 1 ? '4px' : 0 }}>
                                                {clinician.clinician_name} {clinician.clinician_surname} {gender && ` ${gender}`} | {startTime} - {endTime}
                                            </div>
                                        );
                                    })}
                                </div>
                            );

                            return (
                                <Tooltip title={tooltipContent} color="#008385">
                                    {eventInfo.event.title}
                                </Tooltip>
                            );
                        }
                        if (eventData?.type === 'spacer' || eventData?.type === 'block' || eventData?.type === "lunch") {
                            const startTime = moment.utc(eventData.start_time).format('hh:mm a');
                            const endTime = moment.utc(eventData.end_time).format('hh:mm a');

                            const tooltipContent = (
                                <div>
                                    <div>
                                        {eventData.name} | {startTime} - {endTime}
                                    </div>
                                </div>
                            );

                            return (
                                <Tooltip title={tooltipContent} color="#008385">
                                    {eventInfo.event.title}
                                </Tooltip>
                            );
                        }


                        // Default rendering for other events
                        return (
                            <div className='calendarEventNew'>{eventInfo.event.title}</div>
                        );
                    }}
                    eventClassNames="calenderEvent"
                    dayCellClassNames="calendarDays"
                    dayHeaderClassNames="calendarHeader"
                    scrollTime="08:00:00"
                    // resources={props.clinic?.rooms?.map((item, i) => ({
                    //     id: item.id,
                    //     title: `Room ${i + 1}`,
                    //     data: item
                    // }))}
                    resources={props.data?.appointmentData?.map((item, i) => ({
                        id: item.room_id,
                        title: `${item.room_name} ${item?.room_type ? '- ' + item.room_type : ''}`,
                        data: item
                    }))}
                    // IOO-307: Custom room header renders a clickable swap icon
                    resourceLabelContent={(resourceInfo) => {
                        const roomData = resourceInfo?.resource?.extendedProps?.data;
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center', flexWrap: 'wrap' }}>
                                <span style={{ fontWeight: 600, fontSize: 13 }}>
                                    {resourceInfo.resource.title}
                                </span>
                                {isAdmin && props.onRoomHeaderClick && roomData && (
                                    <Tooltip title="Swap clinician availabilty" color="#008385" placement="top">
                                        <span
                                            id={`room-swap-btn-${roomData.room_id}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                props.onRoomHeaderClick(roomData);
                                            }}
                                            style={{
                                                cursor: 'pointer',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 22,
                                                height: 22,
                                                borderRadius: '50%',
                                                background: 'rgba(0,131,133,0.12)',
                                                color: '#008385',
                                                fontSize: 12,
                                                transition: 'background 0.2s',
                                                flexShrink: 0,
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(0,131,133,0.25)'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(0,131,133,0.12)'; }}
                                            title=""
                                        >
                                            <SwapOutlined />
                                        </span>
                                    </Tooltip>
                                )}
                            </div>
                        );
                    }}
                    events={eventDataSet}
                    allDaySlot={false}
                    height="auto"
                    slotEventOverlap={false}
                />
            )}
        </div>
    );
};

export default CalendarOneDay;


